import React from "react";

const RTFRFaq = ({ title, faqs = [] }) => {
  return (
    <section className="rtfr-faq-section">
      <div className="container">
        <h2
          className="text-center"
          data-aos="fade-up"
          data-aos-once="true"
        >
          {title}
        </h2>

        <div
          className="rtfr-faq-list"
          data-aos="fade-up"
          data-aos-delay="150"
          data-aos-once="true"
        >
          {faqs.map((faq, i) => (
            <div key={i} className="rtfr-faq-item">
              <p className="rtfr-faq-q">{faq.q}</p>
              <p className="rtfr-faq-a">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RTFRFaq;
